import { formatFileSize } from "../../utils/helpers/supportFiles";

const FILE_ICON_PATH =
  "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z";

// The attachments of one message: images as thumbnails, everything else as a
// named chip. URLs are the API's signed links — plain hrefs that need no
// Authorization header, so <img src> and a download link both just work.
//
// `onOpen(url)` replaces the default navigation: the Mini App passes Telegram's
// openLink, because a WebView cannot open a download in place.
// `inverted` is for a chip sitting on the "mine" (accent-coloured) bubble.
export default function AttachmentList({ attachments, onOpen, inverted = false, className = "" }) {
  if (!attachments?.length) return null;
  const images = attachments.filter((a) => a.is_image);
  const files = attachments.filter((a) => !a.is_image);

  const handleClick = (event, url) => {
    if (!onOpen) return;
    event.preventDefault();
    onOpen(url);
  };

  return (
    <div className={`space-y-2 ${className}`}>
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {images.map((a) => (
            <a
              key={a.uuid}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => handleClick(e, a.url)}
              className="block rounded-xl overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400"
              title={a.original_name}
            >
              <img
                src={a.url}
                alt={a.original_name}
                loading="lazy"
                className="h-28 w-auto max-w-[220px] object-cover bg-[color:var(--support-chip)]"
              />
            </a>
          ))}
        </div>
      )}
      {files.map((a) => (
        <a
          key={a.uuid}
          href={a.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => handleClick(e, a.url)}
          className={`flex items-center gap-2 max-w-full rounded-xl px-3 py-2 text-xs font-semibold border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 ${
            inverted
              ? "border-white/30 bg-white/10 text-[color:var(--support-mine-text)]"
              : "border-[color:var(--support-border)] bg-[color:var(--support-chip)] text-[color:var(--support-surface-text)]"
          }`}
        >
          <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={FILE_ICON_PATH} />
          </svg>
          <span className="truncate">{a.original_name}</span>
          <span className="shrink-0 opacity-70">{formatFileSize(a.size)}</span>
        </a>
      ))}
    </div>
  );
}
